import { createRoot } from '@wordpress/element';
import { useState, useEffect } from '@wordpress/element';
import apiFetch from '@wordpress/api-fetch';

function MenuItemsBlock({ categoryId }) {
    const [menuItems, setMenuItems] = useState([]);
    const [isLoading, setLoading] = useState(true);

    // Fetch menu items, filtered by category if selected
    useEffect(() => {
        setLoading(true);
        let path = '/wp/v2/menu_item?per_page=100&_embed';

        if (categoryId) {
            path += `&menu-categories=${categoryId}`;
        }

        apiFetch({ path })
            .then((items) => {
                setMenuItems(items);
                setLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching menu items:', error);
                setLoading(false);
            });
    }, [categoryId]);

    if (isLoading) {
        return (
            <div className="menu-items-loading">
                <p>Loading menu items...</p>
            </div>
        );
    }

    if (!menuItems.length) {
        return (
            <div className="menu-items-empty">
                <p>No menu items found.</p>
            </div>
        );
    }

    return (
        <div className="menu-items-block">
            <div className="menu-items-outer-container">
                {menuItems.map((item) => {
                    const featuredImage =
                        item._embedded?.['wp:featuredmedia']?.[0]?.source_url || null;

                    return (
                        <div
                            key={item.id}
                            className="menu-item-outer-container"
                            style={{ marginBottom: '2rem' }}
                        >
                            {featuredImage && (
                                <img
                                    src={featuredImage}
                                    alt={item.title.rendered}
                                    style={{ maxWidth: '100%', height: 'auto' }}
                                />
                            )}
                            <div className="menu-item-inner-container">
                                <h2>{item.title.rendered}</h2>
                                <p>{item.content.rendered.replace(/<\/?[^>]+(>|$)/g, '')}</p>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

// Hydrate all menu item blocks on page load
document.addEventListener('DOMContentLoaded', () => {
    const blocks = document.querySelectorAll('.menu-items-block-wrapper');

    blocks.forEach((block) => {
        const categoryId = block.dataset.categoryId
            ? parseInt(block.dataset.categoryId)
            : null;

        const root = createRoot(block);
        root.render(<MenuItemsBlock categoryId={categoryId} />);
    });
});
